webpackJsonp([96],{

/***/ 1508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = regType;
/**
 * 正则验证方法库
 */
function regType(type) {
  var exp = void 0;

  switch (type) {
    default:
      exp = new RegExp();
      break;
    case 'number':
      // 纯数字
      exp = /^\d+$/gi;
      break;
    case 'email':
      // 邮箱
      exp = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/gi;
      break;
    case 'httpUrl':
      // HTTP/HTTPS URL
      exp = /^(http|https):\/\/([0-9a-z_!~*'()-]+\.)*(([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.)([a-z]{2,6})((\/?)|(\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+(\/?))$/gi;
      break;
    case 'telephone':
      // 手机
      exp = /^1[3456789]\d{9}$/gi;
      break;
    case 'phone':
      // 座机
      exp = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/gi;
      break;
    case 'imgData':
      // data-url图片
      exp = /^data:image\//gi;
      break;
    case 'money':
      // 金额
      exp = /^(\d+)((\.){1,1}(\d){1,2})?$/g;
      break;
  }

  return exp;
}

/***/ }),

/***/ 2632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerTaskForm_js__ = __webpack_require__(3817);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CustomerTaskForm_js__["a"]; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerTaskForm_vue__ = __webpack_require__(2632);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de1d4afc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerTaskForm_vue__ = __webpack_require__(3818);
function injectStyle (ssrContext) {
  __webpack_require__(3815)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de1d4afc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerTaskForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de1d4afc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerTaskForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3815:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3816);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("aa91689a", content, true, {});

/***/ }),

/***/ 3816:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".custom-form .re-el-form__flex[data-v-de1d4afc]{margin:0}.custom-form .el-select[data-v-de1d4afc]{width:100%}.custom-form .form-panel[data-v-de1d4afc]{width:100%;margin:15px 0 0}.custom-form .form-slider[data-v-de1d4afc]{padding:0 0 0 10px}.popover-table[data-v-de1d4afc]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,.5);z-index:999}.popover-table .popover-table-body[data-v-de1d4afc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#fff;border-radius:5px;overflow:hidden}.popover-table .popover-table-body>div[data-v-de1d4afc]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px}.popover-table .popover-table-body .popover-table-header[data-v-de1d4afc]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #aaa}.popover-table .popover-table-body .popover-table-content[data-v-de1d4afc]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto}", "", {"version":3,"sources":["/workspace/src/views/platform-user/style/PlatformUser.scss"],"names":[],"mappings":"AACA,gDAAgD,QAAQ,CACvD,AACD,yCAAyC,UAAU,CAClD,AACD,0CAA0C,WAAW,eAAe,CACnE,AACD,2CAA2C,kBAAkB,CAC5D,AACD,gCAAgC,eAAe,MAAM,SAAS,OAAO,QAAQ,SAAS,gCAAiC,WAAW,CACjI,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,4BAA4B,wBAAwB,uBAAuB,oBAAoB,2BAA2B,eAAe,iBAAiB,cAAc,YAAY,sBAAsB,kBAAkB,eAAe,CAC5Y,AACD,wDAAwD,WAAW,8BAA8B,sBAAsB,YAAY,CAClI,AACD,0EAA0E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,eAAe,gBAAgB,WAAW,6BAA6B,CACrO,AACD,2EAA2E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,aAAa,CAC5K","file":"PlatformUser.scss","sourcesContent":["\n.custom-form .re-el-form__flex[data-v-de1d4afc]{margin:0\n}\n.custom-form .el-select[data-v-de1d4afc]{width:100%\n}\n.custom-form .form-panel[data-v-de1d4afc]{width:100%;margin:15px 0 0\n}\n.custom-form .form-slider[data-v-de1d4afc]{padding:0 0 0 10px\n}\n.popover-table[data-v-de1d4afc]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,0.5);z-index:999\n}\n.popover-table .popover-table-body[data-v-de1d4afc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#FFF;border-radius:5px;overflow:hidden\n}\n.popover-table .popover-table-body>div[data-v-de1d4afc]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px\n}\n.popover-table .popover-table-body .popover-table-header[data-v-de1d4afc]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #AAA\n}\n.popover-table .popover-table-body .popover-table-content[data-v-de1d4afc]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_regExp__ = __webpack_require__(1508);





/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.onLoad();
      vm.setPreviousTable(from);
    });
  },
  data: function data() {
    return {
      inputWith: 12,
      parentPage: { /** 新建客户有两个入口，指定用哪个 **/
        name: '客户列表',
        path: '/customer/table'
      },
      formRules: {
        name: [{ required: true, message: '客户名称不能为空', trigger: 'blur' }],
        number: [{ required: true, message: '客户编号不能为空', trigger: 'blur' }],
        company: [{ required: true, message: '所属公司不能为空', trigger: 'blur' }],
        'contact_persons.0.name': [{ required: true, message: '客户联系人不能为空', trigger: 'blur' }],
        'contact_persons.0.job_title': [{ required: true, message: '职位不能为空', trigger: 'blur' }],
        'contact_persons.0.phone': [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],
        'contact_persons.0.email': [{ required: true, message: '邮箱不能为空', trigger: 'blur' }, { validator: this.emailValidator, trigger: 'blur' }],
        abbr: [{ required: true, message: '客户代码不能为空', trigger: 'blur' }]
      },
      dataModel: {
        name: '',
        number: '',
        abbr: '',
        detail: '',
        type: 10,
        company: '',
        show_in_statistics: 1,
        managementfees: 0,
        supplier_code: '',
        contact_persons: [{
          name: '',
          job_title: '',
          phone: '',
          email: ''
        }, {
          name: '',
          job_title: '',
          phone: '',
          email: ''
        }]
      },
      optionModel: {
        customerType: [{ label: '主平台', value: 10 }, { label: '查理宝客户', value: 20 }, { label: '星火客户', value: 30 }, { label: '标注客户', value: 40 }],
        display: [{ label: '不显示', value: 0 }, { label: '显示', value: 1 }]
      },
      inLoading: {
        submit: false
      },
      tip: ''
    };
  },

  computed: {},
  created: function created() {},

  methods: {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.common('getCustomerDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).map(function (key) {
          var intItems = ['id', 'type', 'show_in_statistics'];
          if (intItems.includes(key)) {
            data[key] = parseInt(data[key]);
          }
          var floatItems = ['managementfees'];
          if (floatItems.includes(key)) {
            data[key] = parseFloat(data[key]) * 100;
          }
          if (data.contact_persons.length <= 1) {
            data.contact_persons.push({
              name: '',
              job_title: '',
              phone: '',
              email: ''
            });
          }
        });

        _this.dataModel = data;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          var form = filter.copyJson(_this2.dataModel);
          var secondPerson = form.contact_persons[1];
          if (!secondPerson.name && !secondPerson.job_title && !secondPerson.phone && !secondPerson.email) {
            form.contact_persons.splice(1, 1);
          }
          _this2.id ? _this2.update(_this2.id, form) : _this2.create(form);
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    phoneValidator: function phoneValidator(rule, value, callback) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils_regExp__["a" /* regType */])('telephone').test(String(value))) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    },
    emailValidator: function emailValidator(rule, value, callback) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils_regExp__["a" /* regType */])('email').test(String(value))) {
        callback(new Error('请输入正确的邮箱地址'));
      } else {
        callback();
      }
    },
    create: function create(form) {
      var _this3 = this;

      request.common('createCustomerTask', form).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
        }, _this3.backToList);
      });
    },
    update: function update(id, form) {
      var _this4 = this;

      request.common('updateCustomerData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: id }, form)).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(_this4.backToList);
      });
    },
    backToList: function backToList() {
      this.$router.push(this.parentPage);
    },
    setPreviousTable: function setPreviousTable(from) {
      if (from.meta.title || from.name) {
        this.parentPage = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, from);
      }
    },
    validateAbbr: function validateAbbr(value) {
      var _this5 = this;

      request.common('validateUniqueAbbr', { abbr: value }).then(function (res) {
        if (res.data.count > 0) {
          var name = '';
          for (var i in res.data.data) {
            name += res.data.data[i].name + ',';
          }
          name = name.substring(0, name.length - 1);
          if (res.data.count > 5) {
            name += '...';
          }
          _this5.tip = '客户代码已存在，' + name;
        }
      });
    }
  }
});

/***/ }),

/***/ 3818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":_vm.parentPage}},[_vm._v(_vm._s(_vm.parentPage.name))]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",attrs:{"model":_vm.dataModel,"rules":_vm.formRules,"label-width":"120px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('el-form-item',{attrs:{"prop":"name","label":"客户名称:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"maxlength":"50","clearable":""},model:{value:(_vm.dataModel.name),callback:function ($$v) {_vm.$set(_vm.dataModel, "name", $$v)},expression:"dataModel.name"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"number","label":"客户编号:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"maxlength":"50","clearable":""},model:{value:(_vm.dataModel.number),callback:function ($$v) {_vm.$set(_vm.dataModel, "number", $$v)},expression:"dataModel.number"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"abbr","label":"客户代码:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"maxlength":"50","clearable":""},on:{"change":_vm.validateAbbr},model:{value:(_vm.dataModel.abbr),callback:function ($$v) {_vm.$set(_vm.dataModel, "abbr", $$v)},expression:"dataModel.abbr"}})],1),_vm._v(" "),_c('span',{staticStyle:{"color":"red","margin-left":"10px"}},[_vm._v(_vm._s(_vm.tip))])],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"company","label":"所属公司:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"maxlength":"50","clearable":""},model:{value:(_vm.dataModel.company),callback:function ($$v) {_vm.$set(_vm.dataModel, "company", $$v)},expression:"dataModel.company"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"type","label":"客户类型:"}},[_c('el-select',{model:{value:(_vm.dataModel.type),callback:function ($$v) {_vm.$set(_vm.dataModel, "type", $$v)},expression:"dataModel.type"}},_vm._l((_vm.optionModel.customerType),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"show_in_statistics","label":"是否显示:"}},[_c('el-select',{model:{value:(_vm.dataModel.show_in_statistics),callback:function ($$v) {_vm.$set(_vm.dataModel, "show_in_statistics", $$v)},expression:"dataModel.show_in_statistics"}},_vm._l((_vm.optionModel.display),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"managementfees","label":"管理费所占比例:"}},[_c('div',{staticClass:"form-slider"},[_c('el-slider',{attrs:{"step":0.1,"show-input":""},model:{value:(_vm.dataModel.managementfees),callback:function ($$v) {_vm.$set(_vm.dataModel, "managementfees", $$v)},expression:"dataModel.managementfees"}})],1)]),_vm._v(" "),_vm._l((_vm.dataModel.contact_persons),function(person,index){return [_c('el-form-item',{attrs:{"label":""}},[_c('template',{slot:"label"},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("客户联系人"+_vm._s(index+1))])])],2),_vm._v(" "),_c('el-form-item',{attrs:{"prop":("contact_persons." + index + ".name"),"label":"客户联系人:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"maxlength":"50","clearable":""},model:{value:(person.name),callback:function ($$v) {_vm.$set(person, "name", $$v)},expression:"person.name"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":("contact_persons." + index + ".job_title"),"label":"职位:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"maxlength":"50","clearable":""},model:{value:(person.job_title),callback:function ($$v) {_vm.$set(person, "job_title", $$v)},expression:"person.job_title"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":("contact_persons." + index + ".phone"),"label":"联系方式:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"maxlength":"50","clearable":""},model:{value:(person.phone),callback:function ($$v) {_vm.$set(person, "phone", $$v)},expression:"person.phone"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":("contact_persons." + index + ".email"),"label":"邮箱:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"maxlength":"50","clearable":""},model:{value:(person.email),callback:function ($$v) {_vm.$set(person, "email", $$v)},expression:"person.email"}})],1)],1),_vm._v(" "),(index === 0)?[_c('el-form-item',{attrs:{"prop":"supplier_code","label":"供应商编号:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"maxlength":"50","clearable":""},model:{value:(_vm.dataModel.supplier_code),callback:function ($$v) {_vm.$set(_vm.dataModel, "supplier_code", $$v)},expression:"dataModel.supplier_code"}})],1)],1)]:_vm._e()]}),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"detail","label":"客户描述:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-input',{attrs:{"clearable":""},model:{value:(_vm.dataModel.detail),callback:function ($$v) {_vm.$set(_vm.dataModel, "detail", $$v)},expression:"dataModel.detail"}})],1)],1),_vm._v(" "),_c('el-row',{staticClass:"form-panel"},[_c('el-button',{attrs:{"type":"primary","size":"mini","native-type":"submit"}},[_vm._v("保存\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.$router.push(_vm.parentPage)}}},[_c('span',[_vm._v("取消")])])],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/CustomerTaskForm.d472967e713cec1ff384.js